import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

export default function DropdownFIlter({searchFilterString, setSearchFilterString, setScrollLock}) {

    const handleChange = (event) => {
        setSearchFilterString(event.target.value);
        setScrollLock(false)
    };

    return (
        <div style={{display: "flex"}}>
            <Box sx={{width: 150}}>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Sector</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={searchFilterString}
                        label="Sector"
                        onChange={handleChange}
                    >
                        <MenuItem value={'Financial'}>Finance</MenuItem>
                        <MenuItem value={'Energy'}>Energy</MenuItem>
                        <MenuItem value={'Services'}>Services</MenuItem>
                        <MenuItem value={'Consumer Cyclical'}>Consumer secondary</MenuItem>
                        <MenuItem value={'Industrials'}>Industrials</MenuItem>
                        <MenuItem value={'Technology'}>Technology</MenuItem>
                        <MenuItem value={'Transportation'}>Transportation</MenuItem>
                        <MenuItem value={'Consumer/Non-Cyclical'}>Consumer main</MenuItem>
                        <MenuItem value={'Materials'}>Materials</MenuItem>
                        <MenuItem value={'Healthcare'}>Healthcare</MenuItem>
                        <MenuItem value={'Utilities'}>Utilities</MenuItem>
                        <MenuItem value={'Basic Materials'}>Basic Materials</MenuItem>
                        <MenuItem value={'Capital Goods'}>Capital Goods</MenuItem>
                        <MenuItem value={'Real Estate'}>Real Estate</MenuItem>
                    </Select>
                </FormControl>
            </Box>
            <IconButton aria-label="delete" disabled={!searchFilterString} onClick={() => {
                setSearchFilterString('')
                setScrollLock(false)
            }}>
                <DeleteIcon/>
            </IconButton>
        </div>
    );
}